<template>
  <div>
    <div class="routerChange">
      <el-button v-show="downloadExcelShow" class="lookUp" type="danger" @click="download" :disabled="picload" icon="el-icon-download">下载</el-button>
      <el-button v-show="!downloadExcelShow" class="lookUp" type="warning" :loading="true" plain>下载..</el-button>
      <el-button class="goBack" @click="goBack">返回</el-button>
      <div class="projectInfo">
        <div class="blockHeader">
          <div class="redBlock"></div>
          <div class="headerText">{{projectDayName}}</div>
        </div>
        <div class="blockContent">
          <div class="blockItem">
            <div class="item_type1">
              <div class="itemLeft">工程名称</div>
              <div class="itemRight">
                <span class="infoShow">{{projectObj.name}}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">工程地址</div>
              <div class="itemRight">
                <span class="infoShow">{{projectObj.address}}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">施工方自评时间</div>
              <div class="itemRight">
                <span class="infoShow">{{comments.consUnitDate}}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">监理方复评时间</div>
              <div class="itemRight">
                <span class="infoShow">{{comments.supervisorDate}}</span>
              </div>
            </div>
          </div>
          <div class="blockItem">
            <div class="item_type1">
              <div class="itemLeft">工程创建时间</div>
              <div class="itemRight">
                <span class="infoShow">{{projectObj.createTime}}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">工程开工时间</div>
              <div class="itemRight">
                <span class="infoShow">{{projectObj.startTime}}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">工程计划竣工时间</div>
              <div class="itemRight">
                <span class="infoShow">{{projectObj.planEndTime}}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">工程实际完成时间</div>
              <div class="itemRight">
                <span class="infoShow">{{projectObj.endTime}}</span>
              </div>
            </div>
          </div>
          <div class="blockItem">
            <div class="item_type1">
              <div class="itemLeft">施工单位</div>
              <div class="itemRight">
                <span class="infoShow">{{projectObj.consUnit}}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">监理单位</div>
              <div class="itemRight">
                <span class="infoShow">{{projectObj.supervisor}}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">工程负责人</div>
              <div class="itemRight">
                <span class="infoShow">
                  <span class="infoShow">{{projectObj.principal}}</span>
                </span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">工程联系电话</div>
              <div class="itemRight">
                <span class="infoShow">
                  <span class="infoShow">
                    <span class="infoShow">{{projectObj.principalPhone}}</span>
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div class="blockItem">
            <div class="item_type2" v-if="workDetails[0].detail.workType==3 ||workDetails[0].detail.workType==4 ">
              <div class="itemLeft">工程总里程</div>
              <div class="itemRight">
                <span class="infoShow">{{getData.sumMileage}} km</span>
              </div>
            </div>
            <div class="item_type2" v-if="workDetails[0].detail.workType==1 || workDetails[0].detail.workType==2">
              <div class="itemLeft">工程总面积</div>
              <div class="itemRight">
                <span class="infoShow">{{getData.sumArea}} m²</span>
              </div>
            </div>
            <div class="item_type2">
              <div class="itemLeft">工程进度</div>
              <div class="itemRight">
                <span class="infoShow">
                  <span class="infoShow">{{(getData.process * 100).toFixed(2) + '%'}}</span>
                </span>
              </div>
            </div>
            <!-- <div class="item_type1">
              <div class="itemLeft"></div>
              <div class="itemRight">
                <span class="infoShow">
                  <span class="infoShow"></span>
                </span>
              </div>
            </div> -->
          </div>
          <div class="blockItem">
            <div class="item_type2">
              <div class="itemLeft">已建立作业</div>
              <div class="itemRight">
                <span class="infoShow">{{getData.workNames}}</span>
              </div>
            </div>
            <div class="item_type2">
              <div class="itemLeft">已完成作业</div>
              <div class="itemRight">
                <span class="infoShow">{{getData.finishedWorkNames}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="projectInfo">
        <div class="blockHeader">
          <div class="redBlock"></div>
          <div class="headerText">工程质量</div>
        </div>
        <div class="comRollContent work-wrapper" v-for="(item,index) in workInfos" :key="index">
          <div class="comRollTitle">{{item.name}}</div>
          <workParameter :workEquipList="item.params"></workParameter>
        </div>
      </div>
      <div class="projectInfo">
        <opinionp :comments="comments" :attachments="attachments" :projectId="projectId" @changeCons="changeConsFun" @changeSuper="changeSupersFun" @changeRadio="changeRadioFun"></opinionp>
      </div>

      <div class="workContent" v-for="(item,index) in workDetails" :key="index">
        <div class="projectInfo workInfo">
          <div class="blockHeader">
            <div class="redBlock"></div>
            <div class="headerText">附：{{item.detail.name}}</div>
          </div>
          <div class="blockContent">
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">作业名称</div>
                <div class="itemRight">
                  <span class="infoShow">{{item.detail.name}}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">作业类型</div>
                <div class="itemRight">
                  <span class="infoShow">{{workTypeMap[item.detail.workType]}}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">作业标段</div>
                <div class="itemRight">
                  <span class="infoShow">{{item.detail.sectionName}}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">作业进度</div>
                <div class="itemRight">
                  <span class="infoShow">{{item.detail.process*100}}%</span>
                </div>
              </div>
            </div>
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">开始施工时间</div>
                <div class="itemRight">
                  <span class="infoShow">{{item.detail.startTime}}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">最后施工时间</div>
                <div class="itemRight">
                  <span class="infoShow">{{item.detail.endTime}}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">开始桩号</div>
                <div class="itemRight">
                  <span class="infoShow">{{item.detail.workType==3||item.detail.workType==4?item.detail.startPileNum:'--'}}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">结束桩号</div>
                <div class="itemRight">
                  <span class="infoShow">{{item.detail.workType==3||item.detail.workType==4?item.detail.endPileNum:'--'}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="projectInfo workInfo">
          <interventionEquip v-if="childShow" :workEquipList="item.detail.equipList"></interventionEquip>
          <compaction v-if="childShow" :workInfo="item.detail" :projectCheck="true"></compaction>
        </div>
        <div class="projectInfo">
          <opinion v-if="childShow" :type="opinionType" :comments="item.comments" :attachments="item.attachments" :workId="item.comments.workId+''"></opinion>
        </div>
      </div>
      <div class="commitCon">
        <span class="searchInputText"><span style="color:red">*</span> 编号</span>
        <el-input placeholder="请输入报告编号" v-model="reportCode"></el-input>
        <span class="resetBtn" @click="resetOpinion">重置</span>
        <span class="commitBtn" @click="setOpinion">提交</span>
      </div>
    </div>
  </div>
</template>

<script>
import { 
  getProjectReport,
  setCommentPro,
    setSupervisorPro
   } from "../../utils/api";
import { Loading } from "element-ui";
import opinion from "./report/opinion";
import opinionp from "./report/opinionp";
import compaction from './report/compaction'
import interventionEquip from './report/interventionEquip'
import workParameter from "./report/workParameter";
import{getDateSeconds,dataURLtoFile} from '../../utils/commons'
import axios from 'axios';
import Cookies from 'js-cookie'
import { Message} from 'element-ui';
export default {
  name: "app",
  data() {
    return {
      opinionType: 'all',
      arrowList: [
        {
          name: '工程中心',
          path: '/transfer/engineeringCenter'
        },
        {
          name: "工程验收",
          path: "/transfer/check",
        },
        {
          name: "工程验收报告",
          path: "",
        },
      ],
      projectDayName: "",
      projectObj: {},
      comments: {},
      workComments: [],
      getData: {},
      workInfos: [],
      workDetails: [],
      childShow: false,
      loadingInstance: '',
      projectComments: '',
      projectId:'',
      // icv_legend: require('../../images/all/icvNum.png'),
      // rn_legend: require('../../images/all/rollNum.png'),
      consUnitComment: '', //施工方意见
      reportCode: '', //编号
      supervisorComment: '', //监理意见
      passFlag: 2, //是否合格
      attachments: '',
      unAcceptWorks:[],//未验收作业列表
      workTypeMap: this.$store.state.workTypeList,
      downloadExcelShow: true,
      picload:true
    };
  },
  computed: {},
  created() {},
  mounted() {
    // let that = this
    this.$store.commit("setArrowList", this.arrowList);
    // let params = this.$route.params;
    this.projectId=this.$route.query.projectId
    let set = {
      projectId: this.$route.query.projectId,
    };
    // let set = {
    //     projectId: 16
    // }
    this.loadingInstance = Loading.service({});
    getProjectReport(set).then((res) => {
      // console.log(res,"resssssssssss");
      let getData = res.data.content.info;
      this.getData = getData;
      this.arrowList[2].name = getData.projectInfo.name
      this.projectDayName = getData.projectInfo.name + "质量验收报告";
      this.projectObj = getData.projectInfo;
      this.comments = getData.comments;
      this.projectComments = getData.comments;
      this.workInfos = getData.workQuantitys;
      this.loadingInstance.close();
      this.workDetails = getData.workDetails
      this.reportCode = getData.comments.reportCode
      this.attachments = getData.attachments
      this.unAcceptWorks=getData.unAcceptWorks
      this.consUnitComment = getData.comments.consUnitComment
      this.supervisorComment = getData.comments.supervisorComment
      this.reportCode = getData.comments.reportCode
      this.passFlag = getData.comments.passFlag
      this.$nextTick(()=>{
        this.childShow = true
      })
      let timer=setInterval(()=>{
        console.log(this.$store.state.rn_view,this.$store.state.icv_view)
        if(this.$store.state.rn_view.length>=this.workDetails.length && this.$store.state.icv_view.length>=this.workDetails.length){
          this.picload=false
          clearInterval(timer)
        }
      },200)
    });
  },
  beforeDestroy(){
    this.loadingInstance.close();
  },
  methods: {
    resetOpinion: function(){
        let joinCode = localStorage.getItem("roleCode")
        if(joinCode == 'role-1ee79e33cca14137a11514b861c1a199'){
            //施工
            this.consUnitComment = ''
            this.comments.consUnitComment = ''
            this.reportCode = ''
        }else if(joinCode == 'role-7bb90c5570ae4fd8b029d2737f89b641'){
            //监理
            this.supervisorComment = ''
            this.comments.supervisorComment = ''
            this.passFlag = 0
        }else if(joinCode == 'role-admin'){
            //管理员
            this.consUnitComment = ''
            this.comments.consUnitComment = ''
            this.reportCode = ''
            this.supervisorComment = ''
            this.comments.supervisorComment = ''
            this.passFlag = 0
        }
      },
    setOpinion: function(){
        let joinCode = localStorage.getItem("roleCode")
        if(joinCode == 'role-1ee79e33cca14137a11514b861c1a199'){
            //施工
            if(this.consUnitComment == ''){
              Message.error('请填写施工单位意见')
              return
            }
            if(this.reportCode == ''){
              Message.error('请填写编号')
              return
            }
            if(this.unAcceptWorks.length>0){
              let str=this.unAcceptWorks.join("、")
              this.$confirm(
                '当前工程存在下列作业未完成验收，需先进行作业验收'+'</br>'+str,
                "提示",
                {
                  confirmButtonText: "前往作业验收",
                  cancelButtonText: "取消",
                  type: "warning",
                  dangerouslyUseHTMLString: true
                }
              ).then(() => {
                this.$router.push({name:'QualityIndex'})
              });
            }else{
              let params = {
                projectId: this.projectId,
                consUnitComment: this.consUnitComment,
                reportCode: this.reportCode
              }
              setCommentPro(params).then(res=>{
                console.log(res)
                if(res.data.code == 200){
                  Message.success('提交成功')
                }
              })
            }
        }else if(joinCode == 'role-7bb90c5570ae4fd8b029d2737f89b641'){
            //监理
            if(this.supervisorComment == ''){
              Message.error('请填写监理单位意见')
              return
            }
            if(this.passFlag == '2'){
              Message.error('请选择评定意见')
              return
            }
            if(this.unAcceptWorks.length>0){
              let str=this.unAcceptWorks.join("、")
              this.$confirm(
                '当前工程存在下列作业未完成验收,需先进行作业验收'+'</br>'+str,
                "提示",
                {
                  confirmButtonText: "前往作业验收",
                  cancelButtonText: "取消",
                  type: "warning",
                  dangerouslyUseHTMLString: true
                }
              ).then(() => {
                this.$router.push({name:'QualityIndex'})
              });
            }else{
            let params = {
              projectId: this.projectId,
              supervisorComment: this.supervisorComment,
              passFlag: this.passFlag,
              
            }
            setSupervisorPro(params).then(res=>{
              console.log(res)
              if(res.data.code == 200){
                 Message.success('提交成功')
              }
            })
          }
        }else if(joinCode == 'role-admin'){
            if(this.consUnitComment == ''){
              Message.error('请填写施工单位意见')
              return
            }
            if(this.reportCode == ''){
              Message.error('请填写编号')
              return
            }
            if(this.supervisorComment == ''){
              Message.error('请填写监理单位意见')
              return
            }
            console.log(this.passFlag,"this.passFlag",this.passFlag=='')
            if(this.passFlag == '2'){
              Message.error('请选择评定意见')
              return
            }
            if(this.unAcceptWorks.length>0){
              let str=this.unAcceptWorks.join("、")
              this.$confirm(
                '当前工程存在下列作业未完成验收,需先进行作业验收'+'</br>'+str,
                "提示",
                {
                  confirmButtonText: "前往作业验收",
                  cancelButtonText: "取消",
                  type: "warning",
                  dangerouslyUseHTMLString: true
                }
              ).then(() => {
                this.$router.push({name:'QualityIndex'})
              });
            }else{
            let params1 = {
              projectId: this.projectId,
              supervisorComment: this.supervisorComment,
              passFlag: this.passFlag,
              
            }
            setSupervisorPro(params1).then(res=>{
              console.log(res)
              if(res.data.code == 200){
                 Message.success('提交成功')
              }
            })
            let params = {
              projectId: this.projectId,
              consUnitComment: this.consUnitComment,
              reportCode: this.reportCode
            }
            setCommentPro(params).then(res=>{
              console.log(res)
              if(res.data.code == 200){
                Message.success('提交成功')
              }
            })
          }
        }else{
          Message.error('您没有验收权限，可联系管理员添加权限！')
        }
      },
    async download(){
        let userRoleList = localStorage.getItem("userRoleList")
        if(userRoleList.indexOf("menu-1eb5389fa0be4e2a8b0c7bd978aab346") < 0){
          Message.error('您没有权限，可联系管理员添加权限！')
          return
        }
        this.downloadExcelShow = false
        this.loadingInstance = Loading.service({text:'下载中...'});
        let fileArr=[];
        // let icv_l= new Image();
        // icv_l.src= this.icv_legend;
        // let rn_l= new Image();
        // rn_l.src= this.rn_legend;
        // let icv_legend = await getBase64Image(icv_l);
        // let rn_legend = await getBase64Image(rn_l);
        console.log(this.$store.state.rn_view,this.$store.state.icv_view,this.$store.state.tp_view)
        for(let i=0;i<this.workDetails.length;i++){
          let workId=this.workDetails[i].detail.id
          let icv_legend = this.$store.state.icv_exam[i];
          let rn_legend = this.$store.state.rn_exam[i];
          let rn='';
          this.$store.state.rn_view.map(item=>{
            if(item.workId==workId){
              rn=item.content
            }
          })
          let icv='';
          this.$store.state.icv_view.map(item=>{
            if(item.workId==workId){
              icv=item.content
            }
          })
          let tp='';
          this.$store.state.tp_view.map(item=>{
            if(item.workId==workId){
              tp=item.content
            }
          })
          console.log(i,'i')
          fileArr.push(dataURLtoFile(icv_legend.src,`w_${workId}_icv_legend`));
          fileArr.push(dataURLtoFile(rn_legend.src,`w_${workId}_rn_legend`));
          fileArr.push(dataURLtoFile(rn.src,`w_${workId}_rn_view`));
          fileArr.push(dataURLtoFile(icv.src,`w_${workId}_icv_view`));
          if(this.workDetails[i].detail.workType==3||this.workDetails[i].detail.workType==4){
            fileArr.push(dataURLtoFile(tp.src,`w_${workId}_tp_view`));
          }
        }
        
        const data=new FormData();
        fileArr.map((item)=>{
          data.append('files',item,item.name)
        })
        let config={
          headers:{'Content-Type':'multipart/form-data',token:Cookies.get('token'),Authorization:Cookies.get('token')},
          responseType: 'blob',
        }
        const InstructionManualvv = await axios.post(this.$store.state.baseUrl+'/construction/exportPdf/quantity/projectAccept?projectId='+this.projectId,data,config)
        if(InstructionManualvv.data.size < 80){
          this.$message({
              message: '下载失败',
              type: 'warning'
          });
          this.downloadExcelShow = true
          this.loadingInstance.close();
          return
        }
        if(InstructionManualvv.data.code){
          this.$message({
              message: InstructionManualvv.data.message,
              type: 'warning'
          });
          this.loadingInstance.close();
          return
        }else{
          this.$message({
              message: '下载成功',
              type: 'success'
          });
          this.downloadExcelShow = true
          this.loadingInstance.close();
        }
        let blob = new Blob([InstructionManualvv.data], {type: 'application/pdf;charset=UTF-8'});
        let fileName = this.projectDayName+getDateSeconds()+'.pdf';
        if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName)
        } else {
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href) //释放内存
        }
      },
    goBack: function () {
      this.$router.go(-1);
    },
    changeConsFun(e){
      console.log(e)
      this.consUnitComment = e
    },
    changeSupersFun(e){
      console.log(e)
      this.supervisorComment = e
    },
    changeRadioFun(e){
      this.passFlag = e*1
    },
  },
  components: {
    workParameter,
    opinion,
    opinionp,
    interventionEquip,
    compaction
  },
};
</script>
<style lang="scss">
.commitCon{
    .el-input{
        width: 180px !important;
        height: 36px !important;
        margin-left: 23px;
        margin-right: 23px;
        font-size: 14px !important;
        .el-input__inner{
            width: 180px !important;
            height: 36px !important;
            border-radius: 1px !important;
        }
    }
}

</style>
<style lang="scss" scoped="">

.projectInfo {
  width: 98.5%;
  height: auto;
  padding-bottom: 21px;
  margin: 0 auto;
  background-color: #ffffff;
  margin-bottom: 12px;
  .comRollContent {
    width: 98.5%;
    margin: 0 auto;
    border: 1px solid #e1e1e1;
    padding-bottom: 12px;
    margin-bottom: 12px;
    .comRollTitle {
      width: 100%;
      height: 49px;
      background: #f1f1f5;
      border-bottom: 1px solid #e1e1e1;
      line-height: 49px;
      padding-left: 21px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #555555;
      margin-bottom: 9px;
    }
  }
  .blockHeader {
    width: 100%;
    height: 58px;
    position: relative;
    .workListTable {
      width: 1200px;
      height: 38px;
      position: absolute;
      top: 15px;
      left: 130px;
      // background-color: aquamarine;
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;

      .workItem {
        &.activeWorkItem {
          background-color: #e96b5a;
          .workItemText {
            color: #ffffff;
          }
        }
        color: #e96b5a;
        background: #fdf0ef;
        border-color: #f6c4bd;
        height: 32px;
        width: auto;
        display: inline-block;
        line-height: 30px;
        font-size: 14px;

        margin-right: 10px;
        margin-left: 10px;
        // padding: 0 30px;
        vertical-align: top;
        border: 1px solid #e96b5a;
        box-sizing: border-box;
        transform: skewX(-20deg);
        cursor: pointer;
        .workItemText {
          display: inline-block;
          height: 100%;
          width: 100%;
          padding: 0 30px;
          line-height: 30px;
          transform: skewX(20deg);
        }
      }
    }
    .redBlock {
      height: 18px;
      width: 4px;
      position: absolute;
      background-color: #e96b5a;
      top: 19px;
      left: 20px;
    }
    .headerText {
      height: 16px;
      line-height: 16px;
      color: #222222;
      display: inline-block;
      position: absolute;
      top: 21px;
      left: 34px;
      font-weight: 600;
    }

    .addBtn {
      position: absolute;
      top: 15px;
      right: 191px;
      border-radius: 2px;
    }
    .deleteBtn {
      position: absolute;
      top: 15px;
      right: 15px;
      border-radius: 2px;
    }
    .copyBtn {
      position: absolute;
      top: 15px;
      right: 133px;
      border-radius: 2px;
    }
    .editBtn {
      position: absolute;
      top: 15px;
      right: 75px;
      border-radius: 2px;
    }
  }
  .parameterContent {
    width: 97.7%;
    height: auto;
    margin: 0 auto;
  }
  .blockContent {
    width: 97.7%;
    margin: 0 auto;
    border-top: 1px solid rgba(225, 225, 225, 1);
    border-left: 1px solid rgba(225, 225, 225, 1);

    .blockItem {
      display: flex;
      height: 45px;
      .item_type1 {
        flex: 1;
      }
      .item_type2 {
        flex: 2;
      }
      .itemLeft {
        width: 140px;
        height: 44px;
        float: left;
        background: rgba(242, 242, 245, 1);
        border-bottom: 1px solid rgba(225, 225, 225, 1);
        border-right: 1px solid rgba(225, 225, 225, 1);
        line-height: 44px;
        padding-left: 15px;
        color: #555555;
        font-size: 14px;
      }
      .itemRight {
        // width: 100%;
        height: 44px;
        line-height: 44px;
        padding-left: 18px;
        color: #555555;
        font-size: 14px;

        overflow: hidden;
        border-bottom: 1px solid rgba(225, 225, 225, 1);
        border-right: 1px solid rgba(225, 225, 225, 1);
        .infoShow {
          width: 100%;
          height: 100%;
          border: 0;
          color: #555555;
          font-size: 14px;
        }
      }
    }
  }
}
.routerChange {
  width: 100%;
  margin-top: -57px;
  padding-top: 57px;
  position: relative;
  padding-bottom: 67px;
  // margin-top: 57px;
  // min-height: 968px;
}
.lookUp {
  position: fixed;
  right: 75px;
  top: 65px;
  z-index: 1000;
}
.goBack {
  position: fixed;
  right: 16px;
  top: 65px;
  z-index: 1000;
}
.workContent{
//     // background-color: #ffffff;
    margin-bottom: 12px;
    .workInfo{
        margin-bottom: 0 !important;
    }
}
.commitCon{
      height: 67px;
      width: 100%;
      position: fixed;
      left: 0;
      bottom: 0;
      background-color: #ffffff;
      padding-top: 15px;
      z-index: 100;
      .resetBtn{
          display: inline-block;
          height: 40px;
          width: 120px;
          text-align: center;
          line-height: 40px;
          background: #F1F1F5;
          border: 1px solid #E1E1E1;
          border-radius: 20px;
          font-size: 14px;
          color: #212121;
          font-weight: 400;
          margin-left: 17px;
          cursor: pointer;
      }
      .commitBtn{
          display: inline-block;
          height: 40px;
          width: 120px;
          text-align: center;
          line-height: 40px;
          background: #E96B5A;
          border-radius: 20px;
          font-size: 14px;
          color: #ffffff;
          font-weight: 400;
          margin-left: 17px;
          cursor: pointer;
      }
  }
</style>